// Stores the company's plan name read by the route guards and centroCustos.
// A company may come without a subscription; the plan of the previously selected
// company must not survive the switch, so the key is removed instead.
export default function persistEmpresaPlano(empresa) {
  const plano = empresa && empresa.assinatura ? empresa.assinatura.plano : null;

  if (plano) {
    localStorage.setItem("empresa_plano", plano);
  } else {
    localStorage.removeItem("empresa_plano");
  }
}
